<template>
  <v-dialog :value="value"
            persistent
            max-width="800px">
    <div class="modal-container">
      <div class="d-flex w-full justify-end">
        <v-btn icon
               @click="$emit('input', false)"
               class="-mt-12 -mr-12">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <img
        loading="lazy"
        :src="imageModal"
        alt="credit card"
        class="mb-8">
      <strong>{{ $t('cashPaymentTitle') }}</strong>
      <strong class="display-3">${{ getInformation.min }} {{ getInformation.coin }}</strong>
      <span>{{ $t('minAmount') }}</span>
      <div class="copier--container p-7 my-3">
        <strong>{{ $t('paymentInfo') }}</strong>
        <div class="mt-4 flex flex-row justify-center">
          <div class="flex flex-column">
            <span>{{ $t('informationName') }}<strong class='ml-3'>{{ getInformation.name }}</strong></span>
            <span>{{ $t('informationBank') }}<strong class='ml-3'>{{ getInformation.bank }}</strong></span>
            <span>{{ $t('informationAccount') }}<strong class='ml-3'>{{ getInformation.account }}</strong></span>
            <span>SWIFT:<strong class='ml-3'>{{ getInformation.swift }}</strong></span>
            <div v-if="getInformation.address"
                 class="flex flex-column">
              <span>{{ $t('informationAddress') }}<strong class='ml-3'>{{ getInformation.address }}</strong></span>
              <span>{{ $t('informationCity') }}<strong class='ml-3'>{{ getInformation.city }}</strong></span>
              <span>{{ $t('informationState') }}<strong class='ml-3'>{{ getInformation.state }}</strong></span>
              <span>ZIP:<strong class='ml-3'>{{ getInformation.zip }}</strong></span>
            </div>
          </div>
          <div>
            <v-icon color="#10AFF7"
                    @click="toCopy">mdi-content-copy</v-icon>
          </div>
        </div>
      </div>
      <span class="text-center">{{ $t('informationEmailMessage') }}<a class='ml-2 font-weight-bold'>{{ getInformation.contact }}</a></span>
      <span class="font-weight-bold mt-3">{{ $t('informationEmailRemind') }}</span>
    </div>
  </v-dialog>
</template>

<script>
import { EventBus } from '@/eventBus'
import BillingService from '@/components/configuration/Services/BillingService'
import { AmountEnum } from '@/components/configuration/Billing/CurrencyEnum'
export default {
  name: 'CashPayment',
  props: ['value'],
  computed: {
    imageModal () {
      return `${process.env.VUE_APP_STORAGE_URL}/files/bluebird/billing/credit-card.svg`
    },
    getInformation () {
      return this.information.usa
    }
  },
  data () {
    return {
      information: {
        usa: {
          name: 'KEYBE INC',
          bank: 'Silicon Valley Bank',
          account: '# 121140399',
          swift: 'SVBKUS6S',
          address: '19148 N Hibiscus ST',
          city: 'Weston',
          state: 'Florida',
          zip: '33332',
          contact: 'fintech@keybe.ai',
          coin: 'USD',
          min: 10
        },
        col: {
          name: 'KEYBE S.A.S',
          bank: 'Bancolombia - Ahorros',
          account: '00500000242',
          swift: 'COLOCOBM',
          contact: 'fintech@keybe.ai',
          coin: 'COP',
          min: 44000
        }
      }
    }
  },
  methods: {
    toCopy () {
      const string = this.objectToString(this.getInformation())
      navigator.clipboard.writeText(string).then(() => {
        EventBus.$emit('toast', 'success', this.$t('copiedToClipboard'))
      }).catch(() => {
        EventBus.$emit('toast', 'error', this.$t('errorCopying'))
      })
    },
    objectToString (object) {
      const output = Object.entries(object).reduce((total, value) => {
        return total + '\n' + value[1]
      }, '\n')
      return output
    },
    async copBalance () {
      const value = await BillingService.getColombiaTRM()
      if (!value.status) return 0
      const amount = (value.data.amount * AmountEnum.MIN_USD || AmountEnum.MIN_COP)
      return amount + (amount * AmountEnum.TRANSACTION_PAY / 100)
    },
    async usdBalance () {
      return 10
    }
  }
}
</script>

<style scoped lang="scss">
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  padding: 4rem
}
.copier--container {
    width: 100%;
    border-radius: 0.5em;
    background-color: #ddd;
}
</style>
